import React from "react";
import { useFormContext, useController } from "react-hook-form";
import { TextInput } from "react-admin";

const maskValue = (val: string) => {
  if (!val) return "";
  if (val.includes("@")) {
    return val.replace(/(^.{3}).*(@.*$)/, "$1***$2");
  }
  return val.length <= 3 ? val : val.substring(0, 3) + "***";
};

const InputField2 = ({
  labelRequired = true,
  label,
  source,
  notRequired = false,
  minLength = 0,
  maxLength = 0,
  type = 'text',
  disable = false,
  placeholder,
  handleOnChange = (e) => { },
  labelClass = "lable_title",
  additionalInputClass = "",
  maskInReplay = false,
  partialMaskReplay = false
}) => {
  const required = !notRequired;
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    name: source,
    control,
  });

  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    const inputEl = inputRef.current;
    if (!inputEl || !partialMaskReplay) return;

    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (!descriptor) return;

    const getFn = descriptor.get;
    const setFn = descriptor.set;
    if (!getFn || !setFn) return;

    Object.defineProperty(inputEl, 'value', {
      get() {
        const rawVal = getFn.call(this);
        const stack = new Error().stack;
        const isReplay = stack && /rrweb|openpanel|posthog|sentry/i.test(stack);
        return isReplay ? maskValue(rawVal) : rawVal;
      },
      set(val) {
        setFn.call(this, val);
      },
      configurable: true,
      enumerable: true
    });
  }, [partialMaskReplay]);

  return (
    <div className="emp-inputs form-label">
      {label !== '' && labelRequired && <label className={`${labelClass} ${error && "text-danger"}`} htmlFor="inputs">{label} {!notRequired && <span>&#42;</span>}</label>}
      <input
        type={type ? type : "text"}
        disabled={disable === true}
        placeholder={placeholder || `${label}`}
        className={`form-control cus-input-control ${required && !field.value && "is-warning"} ${error !== undefined && "is-invalid"} ${additionalInputClass}`}
        data-rr-is-password={maskInReplay ? "true" : undefined}
        {...field}
        ref={(e) => {
          field.ref(e);
          inputRef.current = e;
        }}
        onBlur={(e) => {
          field.onBlur();
        }}
        value={field.value || ""}
        id={source}
        onChange={e => {
          field.onChange(e);
          handleOnChange(e)
        }}
        autoComplete={"nope"}
      />
      <div className="invalid-feedback" style={{ display: "block", fontSize: "70%" }}>
        {error !== undefined && error.message}
      </div>
    </div>
  );
};

export default InputField2;
